<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="dispatchBusiness">
    <Header
      menuName="dispatchPublish"
      :keyWord.sync="keyWord"
      pageName="业务计划"
      :component.sync="component"
    ></Header>
    <Footer :page="0" :mineActive="0">></Footer>
    <publish
      :keyWord.sync="keyWord"
      v-if="component === 'publish'"
      class="publish component"
    ></publish>
    <unPublish
      :keyWord.sync="keyWord"
      v-if="component === 'unPublish'"
      class="unPublish component"
    ></unPublish>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import publish from "./components/publish";
import unPublish from "./components/unPublish";
export default {
  name: "dispatchBusiness",
  components: {
    Footer,
    Header,
    unPublish,
    publish,
  },
  props: {},
  data() {
    return {
      keyWord: "",
      component: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.dispatchBusiness {
  padding-top: 220px;
  padding-bottom: 70px;
}
</style>
